import api from './api';

const countryPageService = {
  async getCountryPage() {
    const response = await api.get('/partners/country-page');
    return response.data;
  },

  async updateCountryPage(data) {
    const response = await api.put('/partners/country-page', data);
    return response.data;
  },

  async uploadImage(file, type) {
    const formData = new FormData();
    formData.append('image', file);
    // Override del default 'application/json' del cliente: pasar undefined fuerza
    // a axios a derivar 'multipart/form-data; boundary=...' al detectar FormData.
    const response = await api.post(`/partners/country-page/upload?type=${type}`, formData, {
      headers: { 'Content-Type': undefined }
    });
    return response.data;
  },

  async deleteImage(url) {
    const response = await api.delete('/partners/country-page/upload', { data: { url } });
    return response.data;
  },

  async importPrevious() {
    const response = await api.post('/partners/country-page/import-previous');
    return response.data;
  },

  async getTemplates() {
    const response = await api.get('/partners/country-page/templates');
    return response.data;
  },

  async applyTemplate(templateType) {
    const response = await api.post('/partners/country-page/apply-template', { templateType });
    return response.data;
  },

  async getWidgetTypes() {
    const response = await api.get('/partners/country-page/widget-types');
    return response.data;
  },

  async generateWidgetContent(widgetType, instruction, context) {
    const response = await api.post('/partners/country-page/ai/generate-widget', { widgetType, instruction, context });
    return response.data;
  },

  async generateImage(prompt, partnerId, imageType, aspectRatio) {
    const response = await api.post('/partners/country-page/ai/generate-image', { prompt, partnerId, imageType, aspectRatio });
    return response.data;
  },

  // Sugerencias curadas de Unsplash. category puede ser un nombre concreto
  // (legal_hero, professional_team, etc.) o 'all' para mapa de categorias.
  async getUnsplashSuggestions(category) {
    const response = await api.get(`/partners/country-page/unsplash-suggestions/${encodeURIComponent(category)}`);
    return response.data;
  },
};

export default countryPageService;
